import React, { useState, useEffect } from "react";
import ChatBar from "../../../components/dashboardcomponents/ChatComponents/ChatBar";
import ChatHeader from "../../../components/dashboardcomponents/ChatComponents/ChatHeader";
import "./style.css";
import ChatMessageComponent from "../../../components/dashboardcomponents/ChatComponents/ChatMessageComponent";
import { ReactComponent as NoChat } from "../../../assets/images/ChatImages/nochat.svg";
import ChatTicketPopup from "../../../components/dashboardcomponents/ChatComponents/ChatTicketPopup";
import ChatTranscriptPopUp from "../../../components/dashboardcomponents/ChatComponents/ChatTranscriptPopUp";
import AssignChat from "../../../components/dashboardcomponents/ChatComponents/AssignChatPopUp";
import ChatSideBar from "../../../components/dashboardcomponents/ChatComponents/ChatSideBar";
import CannedPopup from "../../../components/dashboardcomponents/ChatComponents/CannedPopup";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { archivedRoomApi } from "../../../store/features/archivedRoom";
import { getCustomerRequest } from "../../../store/features/getCustomerRequest";
import { useNavigate } from "react-router-dom";
import { getMessageById } from "../../../store/features/getRoomById";
import { resolveCustomerIdFromGetMessagePayload } from "../../../utils/messagePayloadCustomer";
import { markNotificationsReadForContext } from "../../../store/features/notifications";
import {
  clearOpenRoomCache,
  getOpenRoomCache,
  setOpenRoomCache,
} from "../../../utils/openChatRoomCache";
import { clearArchiveChatListWarmCache } from "../../../utils/archiveChatListWarmCache";
import { clearUnassignedChatListWarmCache } from "../../../utils/unassignedChatListWarmCache";
import { clearActiveChatListWarmCache } from "../../../utils/activeChatListWarmCache";
import { LIVE_CHAT_HOME_PATH } from "../../../config/featureFlags";

function LiveChat() {
  const [latestMsgTime, setLatestMsgTime] = useState(null);
  const [selectUser, setSelectUser] = useState(null);
  const [getRoomId, setGetRoomId] = useState([]);
  const [ticketPopup, setTicketPopup] = useState(false);
  const [transcriptPopup, setTranscriptPopup] = useState(false);
  const [AssignChatPopup, setAssignChatPopup] = useState(false);
  const [chatSideBar, setChatSideBar] = useState(false);
  const [cannedMsg, setCannedMsg] = useState("");
  const [cannedResponse, setCannedResponse] = useState(false);
  const [refreshChatList, setRefreshChatList] = useState(false);
  const [pendingRemoveRoomId, setPendingRemoveRoomId] = useState(null);
  const [pendingAssignedRoomId, setPendingAssignedRoomId] = useState(null);
  const [pendingAssignedClaimForSelf, setPendingAssignedClaimForSelf] =
    useState(true);
  const [typingIndicator, setTypingIndicator] = useState(false);

  const [customerData, setCustomerData] = useState([]);
  const [openRoom, setOpenRoom] = useState(false);
  const [loading, setLoading] = useState(true);
  const [assignedAgentImage, setAssignedAgentImage] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.loginToken);
  const parseVisitorProfileFromMessages = (messages) => {
    if (!Array.isArray(messages) || messages.length === 0) return null;
    const firstVisitorMessage = messages.find((msg) => !msg?.isAgent && typeof msg?.content === "string");
    if (!firstVisitorMessage?.content) return null;

    const lines = firstVisitorMessage.content
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
    const profile = {};

    for (let i = 0; i < lines.length; i += 1) {
      const line = lines[i];
      if (line.includes(":")) {
        const [rawKey, ...rest] = line.split(":");
        const key = rawKey?.trim()?.toLowerCase();
        const inlineValue = rest.join(":").trim();
        const nextValue = lines[i + 1] && !lines[i + 1].includes(":") ? lines[i + 1] : "";
        const value = inlineValue || nextValue;
        if (!value) continue;

        if (key.includes("name")) profile.name = value;
        if (key.includes("email")) profile.email = value;
      }
    }

    if (!profile.name && !profile.email) return null;
    return profile;
  };

  const handleOpenRoom = () => {
    console.log(
      "LiveChat handleOpenRoom ///////////////////////////////////////////"
    );
    setOpenRoom((prev) => !prev);
    // Add optimistic update for chat assignment
    if (selectUser) {
      // Update the selected user's status immediately
      setSelectUser((prev) => ({
        ...prev,
        is_unAssigned: false,
        unAssignedCount: 0,
        num: 0
      }));
    }
  };
  const handleRefreshChatList = () => {
    console.log(
      "refreshing chat list///////////////////////////////////////////"
    );
    const id = selectUserRef.current?.id;
    if (id) clearOpenRoomCache(id);
    clearArchiveChatListWarmCache();
    clearUnassignedChatListWarmCache();
    clearActiveChatListWarmCache();
    setRefreshChatList((prev) => !prev);
  };

  useEffect(() => {
    const roomId = selectUser?.id;
    if (roomId) {
      dispatch(markNotificationsReadForContext({ roomId }));
    }
  }, [dispatch, selectUser?.id]);

  const customerIdRef = React.useRef(null);
  const prevRoomIdRef = React.useRef(null);
  const selectUserRef = React.useRef(selectUser);
  React.useEffect(() => {
    selectUserRef.current = selectUser;
  }, [selectUser]);

  const fetchCustomerData = (cId) => {
    if (!cId) return;

    dispatch(getCustomerRequest({ id: cId }))
      .then(async (data) => {
        if (customerIdRef.current !== cId) return;
        if (data?.payload?.status === 200) {
          const item = data?.payload?.user;
          const row = [{
            id: item?._id,
            name: item?.name,
            email: item?.email,
            time: item?.updatedAt,
            location: item?.location?.city,
            lat: item?.location?.latitude,
            lng: item?.location?.longitude,
            is_guest: item?.is_guest,
            last_seen: item?.last_seen,
            visited_pages: item?.visited_pages,
            visit_count: item?.visit_count,
            chat_count: item?.chat_count,
            ticket_count: item?.ticket_count,
            ip_address: item?.ip_address,
            os: item?.os,
            browser: item?.browser,
          }];
          setCustomerData(row);
          const su = selectUserRef.current;
          if (su?.id) {
            setOpenRoomCache(su.id, !!su.is_archived, { customerData: row });
          }
        } else if (data?.payload?.status === 401) {
          navigate("/login");
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (!selectUser?.id) {
      setGetRoomId([]);
      setCustomerData([]);
      return;
    }

    // Archived rooms load messages in ArchiveUser (RoomByIdHandler). Avoid a second
    // get-message request here (was causing triple API calls and stacked skeletons).
    if (selectUser?.is_archived) {
      return;
    }

    const openedRoomId = selectUser.id;
    let cancelled = false;
    const cached = getOpenRoomCache(openedRoomId, false);
    const hasCachedMessages = cached != null && Array.isArray(cached.messages);
    if (hasCachedMessages) {
      setGetRoomId(cached.messages);
      setAssignedAgentImage(cached.assignedAgentImage ?? null);
      setSelectUser((prev) => {
        if (!prev || prev.id !== openedRoomId) return prev;
        return { ...prev, ...(cached.selectUserMerge || {}) };
      });
      if (cached.customerData?.length) {
        setCustomerData(cached.customerData);
        const cid =
          selectUser?.customerId ||
          selectUser?.roomUsers?.[0] ||
          cached.selectUserMerge?.customerId ||
          cached.selectUserMerge?.roomUsers?.[0] ||
          cached.customerData[0]?.id;
        if (cid) customerIdRef.current = cid;
      }
      setLoading(false);
    } else {
      setLoading(true);
    }

    // Messages that arrive while a different chat is open never reach this room's
    // cache, so always revalidate. The cached paint above keeps it flicker-free.
    dispatch(getMessageById({ id: openedRoomId }))
        .then(async (data) => {
          if (cancelled) return;
          if (typeof data.payload === "undefined") {
            if (!hasCachedMessages) {
              toast.error("Some Error Occured. Please try again later.");
              setGetRoomId([]);
            }
            setLoading(false);
          } else if (data?.payload?.status === 200) {
            const messages = Array.isArray(data?.payload?.messages) ? data.payload.messages : [];
            setGetRoomId(messages);
            setAssignedAgentImage(data.payload?.assignedAgent?.agent_image);

            const payloadRoom =
              data?.payload?.room ||
              data?.payload?.chatRoom ||
              data?.payload?.data?.room ||
              null;
            const payloadUsers = Array.isArray(payloadRoom?.users) ? payloadRoom.users : [];
            const loggedInAgentId = userData?.response?.user?._id;
            const visitorUser =
              payloadUsers.find(
                (user) => user?._id && user?._id !== loggedInAgentId && user?.is_guest
              ) ||
              payloadUsers.find(
                (user) => user?._id && user?._id !== loggedInAgentId
              ) ||
              payloadUsers[0] ||
              null;
            const roomUsers = payloadUsers.map((user) => user?._id).filter(Boolean);
            const lastVisitorMessage = [...messages].reverse().find((msg) => !msg?.isAgent) || null;
            const resolvedCustomerId = resolveCustomerIdFromGetMessagePayload(data.payload, {
              prevCustomerId: selectUser?.customerId,
              loggedInAgentId,
              payloadUsers,
              visitorMessage: lastVisitorMessage,
            });

            const mergedCustomerId =
              selectUser?.customerId || resolvedCustomerId || null;
            const mergedRoomUsers =
              selectUser?.roomUsers?.length > 0
                ? selectUser.roomUsers
                : roomUsers.length
                  ? roomUsers
                  : resolvedCustomerId
                    ? [resolvedCustomerId]
                    : [];

            setSelectUser((prev) => {
              if (!prev || prev.id !== openedRoomId) return prev;
              const hasCustomerId = !!prev.customerId;
              const hasRoomUsers = prev?.roomUsers?.length > 0;
              if (hasCustomerId && hasRoomUsers) return prev;
              return {
                ...prev,
                customerId: hasCustomerId ? prev.customerId : (resolvedCustomerId || null),
                roomUsers: hasRoomUsers
                  ? prev.roomUsers
                  : (roomUsers.length ? roomUsers : (resolvedCustomerId ? [resolvedCustomerId] : [])),
              };
            });

            const cachePayload = {
              messages,
              assignedAgentImage: data.payload?.assignedAgent?.agent_image ?? null,
              selectUserMerge: {
                customerId: mergedCustomerId,
                roomUsers: mergedRoomUsers,
              },
            };

            if (!resolvedCustomerId && !selectUser?.customerId) {
              const parsedProfile = parseVisitorProfileFromMessages(messages);
              if (parsedProfile) {
                const guestRow = [{
                  id: null,
                  name: parsedProfile.name || "",
                  email: parsedProfile.email || "",
                  time: lastVisitorMessage?.createdAt || "",
                  location: "",
                  lat: null,
                  lng: null,
                  is_guest: true,
                  last_seen: "",
                  visit_count: 0,
                  chat_count: 0,
                  ticket_count: 0,
                  ip_address: "",
                  os: "",
                  browser: "",
                  visited_pages: [],
                }];
                setCustomerData(guestRow);
                cachePayload.customerData = guestRow;
              }
            }
            setOpenRoomCache(openedRoomId, false, cachePayload);
            setLoading(false);
          } else {
            if (!hasCachedMessages) setGetRoomId([]);
            setLoading(false);
          }
        })
        .catch(async (error) => {
          if (cancelled) return;
          if (!hasCachedMessages) {
            toast.error(error);
            setGetRoomId([]);
          }
          setLoading(false);
        });

    return () => {
      cancelled = true;
    };
  }, [selectUser?.id, selectUser?.is_archived, dispatch, userData?.response?.user?._id]);

  useEffect(() => {
    const roomId = selectUser?.id || null;
    const isArchived = !!selectUser?.is_archived;
    const cId = selectUser?.customerId || selectUser?.roomUsers?.[0] || null;
    const roomChanged = roomId !== prevRoomIdRef.current;
    const cached = roomId ? getOpenRoomCache(roomId, isArchived) : null;

    if (roomChanged) {
      prevRoomIdRef.current = roomId;
      customerIdRef.current = null;
      if (cached?.customerData?.length) {
        setCustomerData(cached.customerData);
        const skipId =
          cId ||
          selectUser?.roomUsers?.[0] ||
          selectUser?.customerId ||
          cached.selectUserMerge?.customerId ||
          cached.selectUserMerge?.roomUsers?.[0] ||
          cached.customerData[0]?.id;
        if (skipId) customerIdRef.current = skipId;
      } else {
        setCustomerData([]);
      }
    }

    if (!cId) {
      if (cached?.customerData?.length) return;
      return;
    }

    if (customerIdRef.current === cId) return;
    customerIdRef.current = cId;

    if (!roomChanged) setCustomerData([]);
    fetchCustomerData(cId);
  }, [selectUser?.id, selectUser?.customerId, selectUser?.roomUsers?.[0], selectUser?.is_archived]);

  useEffect(() => {
    if (!selectUser?.id || loading) return;
    const archived = !!selectUser.is_archived;
    if (!getOpenRoomCache(selectUser.id, archived)) return;
    setOpenRoomCache(selectUser.id, archived, { messages: getRoomId });
  }, [getRoomId, selectUser?.id, selectUser?.is_archived, loading]);

  useEffect(() => {
    if (!selectUser?.id || loading) return;
    const archived = !!selectUser.is_archived;
    if (!getOpenRoomCache(selectUser.id, archived)) return;
    if (!customerData?.length) return;
    setOpenRoomCache(selectUser.id, archived, { customerData });
  }, [customerData, selectUser?.id, selectUser?.is_archived, loading]);

  const handleArchivedRoom = () => {
    if (!selectUser) return;
    const roomId = selectUser.id;
    // Leave the open thread before the archive socket can paint the
    // "closed by an agent" fallback on this conversation.
    clearOpenRoomCache(roomId);
    setSelectUser(null);
    setGetRoomId([]);
    setChatSideBar(false);
    setPendingRemoveRoomId(roomId);
    navigate(`${LIVE_CHAT_HOME_PATH}?tab=closed`);

    dispatch(
      archivedRoomApi({
        id: roomId,
      })
    )
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.");
        } else if (
          data?.payload?.status === 200 ||
          data?.payload?.success === true
        ) {
          // List counts / Closed tab refresh are handled via removeRoomId.
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.");
        } else if (data?.payload?.status === 401) {
          toast.error("Some Error Occured. Please try again later.");
        }
      })
      .catch(async (error) => {
        toast.error(error);
      });
  };

  console.log(selectUser, "selectUser in LiveChat");
  return (
    <div className="LiveChat-Main-Container">
      <div className="ChatBar-User-Container">
        <ChatBar
          setLatestMsgTime={setLatestMsgTime}
          selectUser={selectUser}
          setSelectUser={setSelectUser}
          setGetRoomId={setGetRoomId}
          getRoomId={getRoomId}
          setAssignedAgentImage={setAssignedAgentImage}
          refreshChatList={refreshChatList}
          openRoom={openRoom}
          typingIndicator={typingIndicator}
          setTypingIndicator={setTypingIndicator}
          setChatSideBar={setChatSideBar}
          isRoomOpen={chatSideBar}
          setRoomMessagesLoading={setLoading}
          removeRoomId={pendingRemoveRoomId}
          onRemoveRoomConsumed={() => setPendingRemoveRoomId(null)}
          assignedRoomId={pendingAssignedRoomId}
          assignedRoomClaimForSelf={pendingAssignedClaimForSelf}
          onAssignedRoomConsumed={() => {
            setPendingAssignedRoomId(null);
            setPendingAssignedClaimForSelf(true);
          }}
        />
      </div>
      <div className="ChatUser-Header-Container">
        {selectUser && (
          <ChatHeader
            customerData={customerData}
            archivedRoom={handleArchivedRoom}
            setAssignChatPopup={setAssignChatPopup}
            latestMsgTime={latestMsgTime}
            selectUser={selectUser}
            setTicketPopup={setTicketPopup}
            setTranscriptPopup={setTranscriptPopup}
          />
        )}

        {selectUser ? (
          <div className="ChatMessage-Container">
            <ChatMessageComponent
              typingIndicator={typingIndicator}
              setTypingIndicator={setTypingIndicator}
              unArchivedRoom={handleRefreshChatList}
              selectUser={selectUser}
              setSelectUser={setSelectUser}
              setChatSideBar={setChatSideBar}
              setCannedMsg={setCannedMsg}
              setCannedResponse={setCannedResponse}
              getRoomId={getRoomId}
              assignedAgentImage={assignedAgentImage}
              loading={loading}
              setGetRoomId={setGetRoomId}
              triggerOpenRoom={handleOpenRoom}
              onRoomAssigned={(roomId) => {
                setPendingAssignedClaimForSelf(true);
                setPendingAssignedRoomId(roomId);
              }}
            />
          </div>
        ) : (
          <div className="NoChat-Main-Container">
            <NoChat />
            <p className="NoOngoing-Chat">No chats</p>
            <p className="NoOngoingChat01">
              Why not see who's on your website right now and start a chat
              proactively?
            </p>
            <button className="NoOngoing-Chat-Button" type="button">
              Explore Traffic List
            </button>
          </div>
        )}

        {ticketPopup && (
          <ChatTicketPopup
            setTicketPopup={setTicketPopup}
            selectUser={selectUser}
          />
        )}
        {transcriptPopup && (
          <ChatTranscriptPopUp
            setTranscriptPopup={setTranscriptPopup}
            selectUser={selectUser}
          />
        )}

        {AssignChatPopup && (
          <AssignChat
            selectUser={selectUser}
            setSelectUser={setSelectUser}
            setAssignChatPopup={setAssignChatPopup}
            assignChat={handleRefreshChatList}
            setChatSideBar={setChatSideBar}
            onRoomAssigned={(roomId, { claimForSelf = false } = {}) => {
              setPendingAssignedClaimForSelf(claimForSelf);
              setPendingAssignedRoomId(roomId);
            }}
          />
        )}

        {cannedResponse && (
          <CannedPopup
            cannedMsg={cannedMsg}
            setCannedResponse={setCannedResponse}
          />
        )}
      </div>
      {chatSideBar && (
        <div className="LiveChat-Sidebar-Conatiner">
          <ChatSideBar
            customerData={customerData}
            setCustomerData={setCustomerData}
            getRoomId={getRoomId}
            setChatSideBar={setChatSideBar}
            loading={loading}
            customerId={selectUser?.customerId || selectUser?.roomUsers?.[0] || null}
          />
        </div>
      )}
    </div>
  );
}

export default LiveChat;
